<template>
  <div>
    <!-- <Breadcrumb :links="breadcrumbs" /> -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3">
          <li>
            <router-link to="/config" class="">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
          </li>
          <li>
            <h3>{{ $t("system.label.ViewEventActionMapping") }}</h3>
          </li>
        </ul>
      </div>
      <div class="vx-col w-full">
        <vx-card title no-shadow card-border>
          <div class="block overflow-x-auto">
            <table class="table w-full table-bordered table-striped">
              <tr>
                <td>
                  <b>{{ $t("system.label.id") }}</b>
                </td>
                <td>{{ createEventMap.id }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("system.label.Event") | translate }}</b>
                </td>
                <td>{{ createEventMap.eventName }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("system.label.Action") | translate }}</b>
                </td>
                <td>{{ createEventMap.actionName }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("system.label.Process") | translate }}</b>
                </td>
                <td>{{ createEventMap.process }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("system.label.OrderBY") | translate }}</b>
                </td>
                <td>{{ createEventMap.orderBy }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("system.label.itemdescription") | translate }}</b>
                </td>
                <td>{{ createEventMap.prePost }}</td>
              </tr>
              <tr>
                <td class="border-none">
                  <b>{{ $t("system.label.ProcessParams") | translate }}</b>
                </td>
                <td class="border-none">{{ createEventMap.processParams }}</td>
              </tr>
            </table>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      breadcrumbs: [
        { name: this.$t("reports.label.configurations"), to: "/config" },
        { name: this.$t("View Event Action Mapping"), to: "/" },
      ],
      createEventMap: {},
    };
  },

  computed: {
    ...mapGetters({ editEventAction: "system/getEditEventActionData" }),
  },
  methods: {
    async editEventActionDataById() {
      try {
        this.$store
          .dispatch("configuration/setEditEventAction", this.$route.params.id)
          .then((response) => {
            this.createEventMap = response.data;
            // this.createEventMap.action = response.data.actionName;
            // this.createEventMap.process = response.data.process;
            // this.createEventMap.orderBy = response.data.orderBy;
            // this.createEventMap.prePost = response.data.prePost;
            // this.createEventMap.issynchronous = response.data.issynchronous;
            // this.createEventMap.processParams = response.data.processParams;
          });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },

  mounted() {
    this.editEventActionDataById();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
